import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

const Loading = ({ width, height, handleLoadingShow }) => {
    const [num, setNum] = useState(0);

    useEffect(() => {
        /* eslint-disable no-undef */
        const progress = { num: 0 };

        TweenLite.to(progress, 1.8, {
            num: 100,
            onUpdate: () => {
                setNum(progress.num.toFixed(0));
            },
            onComplete: () => {
                handleLoadingShow();
            },
        });
        /* eslint-enable no-undef */
    }, []);

    return (
        <div id="loading" className={styles.loading} style={{ width, height }}>
            <div className={styles.logo} />
            <div className={styles.progress_box}>
                <div className={styles.progress}>
                    <div style={{ width: `${num}%` }} />
                </div>
                <span>{`${num}%`}</span>
            </div>
            <div className={styles.bottom} />
        </div>
    );
};

Loading.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    handleLoadingShow: PropTypes.func,
};

export default errorBoundary(Loading);
